<!--  -->
<template>
  <div class="" style="padding-bottom: 50px">
    <div class="dropdown">
      <el-select
        v-model="value"
        class="dropdown"
        placeholder="请选择学届"
        @visible-change="dropdownAcademicSelectSearch"
        @change="chooseAcademicValue"
      >
        <el-option
          v-for="item in AcademicOptions"
          :key="item.Id"
          :value="item.Id"
          :label="item.Name"
        >
        </el-option>
      </el-select>
      <el-select
        v-if="userInfo.uID == 12"
        v-model="SchoolName"
        placeholder="请选择所属幼儿园"
        @visible-change="onScrollData"
        @change="onChangeScrollData"
        style="margin-right: 10px"
      >
        <el-option
          v-for="item in SchoolList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>

      <el-input
        v-model="cycleName"
        placeholder="请输入周期名称"
        style="width: 200px"
      ></el-input>

      <el-button
        type="primary"
        style="margin-left: 10px"
        @click="GetCycleTimeInfoByPageList"
        >查询</el-button
      >
      <el-button type="primary" @click="addCycle">新增</el-button>
      <el-button type="primary" @click="clear">清空</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin: 0 auto"
        :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
        empty-text="暂无数据"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column label="序号" width="55" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="StudyYearName" label="学届" align="center">
        </el-table-column>
        <el-table-column prop="CycleName" label="周期名称" align="center">
        </el-table-column>
        <el-table-column prop="SchoolName" label="所属幼儿园" align="center">
        </el-table-column>
        <el-table-column prop="GradeName" label="年级" align="center">
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.IsOpen"
              active-text="开启"
              inactive-text="关闭"
              :active-value="0"
              :inactive-value="1"
              @change="onChangeOpen($event, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #e14747"
              @click="onClickDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
     <template slot-scope="scope">
        <el-button
          size="mini"
          type="primary"
          @click="handleEdit(scope.$index, scope.row)"
         >编辑</el-button>
      </template>
    </el-table-column> -->
      </el-table>
    </div>
    <el-dialog :title="nameTitle" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          :label-position="`top`"
        >
          <el-form-item label="周期名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              :disabled="checkStatus"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属幼儿园">
            <el-select
              v-model="ruleForm.addSchoolName"
              placeholder="请选择幼儿园"
              @visible-change="addOnScrollData"
            >
              <el-option
                v-for="item in addSchoolList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学届">
            <el-select
              v-model="ruleForm.StudyName"
              placeholder="请选择学届"
              @visible-change="dropdownAcademicSelect"
              :disabled="checkStatus"
            >
              <el-option
                v-for="item in optionsStudy"
                :key="item.Name"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级">
            <el-select
              v-model="ruleForm.Grade"
              placeholder="请选择年级"
              @visible-change="dropdownGradeSelect"
              :disabled="checkStatus"
            >
              <el-option
                v-for="item in optionsGrade"
                :key="item.Name"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            nameTitle == '新增'
              ? submitForm('ruleForm')
              : EditsubmitForm('ruleForm')
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-PageIndex="PageIndex"
        :PageIndex-sizes="[10, 20, 30, 40]"
        :PageIndex-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
      <!-- <el-button-group style="line-height: 36px">
        <el-button @click="prevPage" icon="el-icon-arrow-left"
          >上一页</el-button
        >
        <el-button @click="nextPage"
          >下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button
        >&nbsp;&nbsp;&nbsp;&nbsp;当前{{ PageIndex }}页
        <el-button class="last_btn" @click="LastPage">尾页</el-button
        >&nbsp;&nbsp;&nbsp;&nbsp;共{{ pageCount }}页
      </el-button-group> -->
    </div>
  </div>
</template>

<script>
import { number } from "echarts/lib/export";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  GetCycleTimeInfoByPage,
  getAcademicSelect,
  getCycleSelect,
  LifeCycleOpen,
  LifeCycleClose,
  GetGradeList,
  AddCycleInfo,
  UpdateCycleInfo,
  DeleteCycleInfo,
  GetSchoolList,
  UpdateCycleTimeInfo,
} from "../../api/api";
export default {
  data() {
    //这里存放数据
    return {
      title: "周期管理",
      tableData: [],
      dialogVisible: false,
      checkStatus: false,
      value: "",
      AcademicName: "", //学届名称
      AcademicId: "", //学届ID
      type: "", //类型
      cycle: "", //周期
      AcademicOptions: [], //学届下拉列表
      cycleOptions: [], //周期下拉列表
      dropdownId: [], //多选信息id
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      ruleForm: {
        name: "",
        StudyName: "",
        Grade: "",
        sort: "",
        addSchoolName: 0,
        Id: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入周期名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      optionsStudy: [], //学届下拉
      optionsGrade: [],
      nameTitle: "新增",
      SchoolList: [],
      SchoolName: null,
      addSchoolList: [],
      testOpen: "1",
      cycleName: "",
      userInfo: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetCycleTimeInfoByPageList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetCycleTimeInfoByPageList();
    },
    async onScrollData() {
      let res = await GetSchoolList();
      if (res.data.success) {
        this.SchoolList = res.data.response;
      }
    },
    async addOnScrollData() {
      let res = await GetSchoolList();
      if (res.data.success) {
        this.addSchoolList = res.data.response;
      }
    },
    onChangeScrollData(e) {
      this.SchoolName = e;
      this.GetCycleTimeInfoByPageList();
    },
    //删除
    onClickDelete(item) {
      this.$confirm("确认提交吗？", "提示", {}).then((res) => {
        DeleteCycleInfo({ ids: [item.Id] }).then((res) => {
          if (res.status == 200) {
            this.GetCycleTimeInfoByPageList();
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
        });
      });
    },

    // 编辑
    onClickEdit(item) {
      getAcademicSelect({ schoolId: item.SchoolId }).then((res) => {
        if (res.data.success) {
          this.addOnScrollData();
          this.optionsStudy = res.data.response;
          this.nameTitle = "编辑";
          this.dialogVisible = true;
          this.checkStatus = true;
          //console.log(item);
          this.ruleForm = {
            name: item.CycleName,
            StudyName: Number(item.StudyYearId),
            Grade: item.GradeId,
            addSchoolName: Number(item.SchoolId),
            Id: item.Id,
          };
        }
      });
      //console.log(item);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.StudyName != "" && this.ruleForm.Grade != "") {
            const params = {
              schoolId:
                this.userInfo.uID == 12
                  ? this.ruleForm.addSchoolName
                  : this.userInfo.SchoolId,
              cycleName: this.ruleForm.name,
              GradeId: this.ruleForm.Grade,
              studyYearId: this.ruleForm.StudyName,
              SchoolType: 3,
            };
            //console.log(params);
            AddCycleInfo(params).then((res) => {
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.dialogVisible = false;
                this.GetCycleTimeInfoByPageList();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
            });
          } else {
            this.$message({
              type: "error",
              message: "请选择对应选项",
            });
          }
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    EditsubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            Id: this.ruleForm.Id,
            sort: this.ruleForm.sort,
          };
          UpdateCycleInfo(params).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.dialogVisible = false;
              this.GetCycleTimeInfoByPageList();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    //下拉年级菜单
    dropdownGradeSelect() {
      GetGradeList({
        schoolId:
          this.userInfo.uID == 12
            ? this.ruleForm.addSchoolName
            : this.userInfo.SchoolId,
      }).then((res) => {
        //  //console.log(res);
        this.optionsGrade = res.data.response;
      });
    },

    addCycle() {
      this.ruleForm = {
        name: "",
        StudyName: "",
        Grade: "",
        sort: "",
        Id: 0,
      };
      this.dialogVisible = true;
      this.checkStatus = false;
    },
    //编辑
    // handleEdit(index, row){
    //   //console.log(index, row);
    // },
    async GetCycleTimeInfoByPageList() {
      let params = {
        pageIndex: this.PageIndex,
        PageSize: this.PageSize,
        SchoolId:
          this.userInfo.uID == 12 ? this.SchoolName : this.userInfo.SchoolId,
        StudyYearId: this.value == "" ? 0 : this.value,
      };
      let res = await GetCycleTimeInfoByPage(params);

      if (res.data.success) {
        // //console.log(res.data.response.data);
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;

        // //console.log(this.pageCount);
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    //多选  获取id
    // handleSelectionChange(val) {
    //   // //console.log(val);
    //   let list = [];
    //   val.forEach((item) => {
    //     //  //console.log(item.Id);
    //     if (!list.includes(item.Id)) {
    //       list.push(item.Id);
    //     }
    //   });
    //   this.dropdownId = list;
    // },
    //下拉学届菜单接口
    dropdownAcademicSelect(show) {
      if (show === true) {
        getAcademicSelect({
          schoolId:
            this.userInfo.uID == 12
              ? this.ruleForm.addSchoolName
              : this.userInfo.SchoolId,
        }).then((res) => {
          if (res.data.success) {
            // //console.log(res.data.response);
            this.optionsStudy = res.data.response;
          }
        });
      }
    },
    dropdownAcademicSelectSearch(show) {
      console.log(this.ruleForm.addSchoolName);
      if (show === true) {
        getAcademicSelect({
          schoolId:
            this.userInfo.uID == 12
              ? this.ruleForm.addSchoolName
              : this.userInfo.SchoolId,
        }).then((res) => {
          if (res.data.success) {
            // //console.log(res.data.response);
            this.AcademicOptions = res.data.response;
          }
        });
      }
    },
    //选择学届菜单项
    chooseAcademicValue(name) {
      // console.log(name);
      // this.AcademicName = name;
      // var obj = {};
      // obj = this.AcademicOptions.find((item) => {
      //   return item.Id == name;
      // });
      // console.log(obj);
      // this.AcademicId = obj.Id;
    },
    //下拉周期菜单接口
    // dropdownCycleSelect(show) {
    //   // //console.log(this.AcademicName, this.AcademicId);
    //   if (show == true) {
    //     getCycleSelect({
    //       StudyYearName: this.AcademicName,
    //       StudyYearId: this.AcademicId,
    //     }).then((res) => {
    //       //console.log(res);
    //       this.cycleOptions = res.data.response;
    //     });
    //   }
    // },
    //选择周期菜单项
    // chooseCycleValue(name) {
    //   this.AcademicName = name;
    // },

    clear() {
      this.SchoolName = undefined;
      this.cycleName = "";
    },
    async onChangeOpen(e, item) {
      //console.log(e, item);
      let params = {
        ids: [item.Id],
        isOpen: e,
      };
      let res = await UpdateCycleTimeInfo(params);
      if (res.data.success) {
        this.GetCycleTimeInfoByPageList();
      }
    },
    //开启状态
    OpenStatus(Id, YeraId) {
      LifeCycleOpen({
        Id: YeraId,
        ids: [Id],
      }).then((res) => {
        if (res.data.success) {
          this.GetCycleTimeInfoByPageList();
          this.PageIndex = 1;
          this.$message({
            message: "开启成功",
            type: "success",
          });
        }
      });
    },
    //关闭状态
    // CloseStatus(Id) {
    //   LifeCycleClose({ Id: Id }).then((res) => {
    //     if (res.status == 200) {
    //       this.GetCycleTimeInfoByPageList();
    //       // //console.log(res);
    //       this.$message({
    //         message: "成功关闭",
    //         type: "success",
    //       });
    //     }
    //   });
    // },
    //上一页 prevPage
    prevPage() {
      if (this.PageIndex > 1) {
        this.PageIndex--;
        GetCycleTimeInfoByPage({
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
        }).then((res) => {
          if (res.data.success) {
            // //console.log(res.data.response.data);
            this.tableData = res.data.response.data;
            this.pageCount = res.data.response.pageCount;
            // //console.log(this.pageCount);
          } else {
            this.tableData = [];
            this.pageCount = 0;
          }
        });
      } else {
        this.$message({
          message: "当前已是首页",
        });
      }
    },
    //下一页 nextPage
    nextPage() {
      if (this.PageIndex < this.pageCount) {
        this.PageIndex++;
        GetCycleTimeInfoByPage({
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
        }).then((res) => {
          if (res.data.success) {
            // //console.log(res.data.response.data);
            this.tableData = res.data.response.data;
            this.pageCount = res.data.response.pageCount;
            // //console.log(this.pageCount);
          } else {
            this.tableData = [];
            this.pageCount = 0;
          }
        });
      } else {
        this.$message({
          message: "当前已是尾页",
        });
      }
    },
    //尾页
    LastPage() {
      this.PageIndex = this.pageCount;
      GetCycleTimeInfoByPage({
        PageIndex: this.pageCount,
        PageSize: this.PageSize,
      }).then((res) => {
        if (res.data.success) {
          // //console.log(res.data.response.data);
          this.tableData = res.data.response.data;
          this.pageCount = res.data.response.pageCount;
          // //console.log(this.pageCount);
        } else {
          this.tableData = [];
          this.pageCount = 0;
        }
      });
    },
  },

  mounted() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetCycleTimeInfoByPageList();
  },
};
</script>
<style scoped>
.colorBlur {
  color: #a0cfff !important;
}
.dropdown {
  margin-right: 10px;
}
.btns {
  margin-top: 20px;
  margin-left: 20px;
}
.search {
  margin-left: 30px !important;
}
.table {
  margin: 20px 0 0 0;
}
.paging {
  margin-left: 20px;
  margin-top: 20px;
}
.last_btn {
  margin-left: 20px !important;
}
</style>